export const emailState = [
  {
    condition: 'contains_set_of',
    value: '',
    type: 'emailContains' as const,
    sequence: 1,
    fieldName: 'email',
  },
  {
    condition: 'does not contain',
    value: '',
    sequence: 2,
    type: 'emailDoesNotContains' as const,
    fieldName: 'email',
  },
]

export const screenNameState = [
  {
    condition: 'contains_set_of',
    value: '',
    type: 'screenNameContains' as const,
    sequence: 1,
    fieldName: 'login',
  },
  {
    condition: 'does not contain',
    value: '',
    type: 'screenNameDoesNotContains' as const,
    sequence: 2,
    fieldName: 'login',
  },
]

export const joinedState = [
  {
    fieldName: 'joined',
    condition: 'before',
    sequence: 1,
    value: null,
    type: 'joinDateBefore',
    UIValue: null,
  },
  {
    fieldName: 'joined',
    condition: 'after',
    value: null,
    sequence: 2,
    type: 'joinDateAfter',
    UIValue: null,
  },
  {
    fieldName: 'joined',
    condition: 'more_than',
    sequence: 3,
    value: null,
    type: 'joinDateMoreThan',
  },
  {
    fieldName: 'joined',
    condition: 'less_than',
    sequence: 4,
    value: null,
    type: 'joinDateLessThan',
  },
]

export const lastState = [
  {
    fieldName: 'last_visited',
    condition: 'before',
    sequence: 1,
    value: null,
    UIValue: null,
    type: 'lastSeenBefore',
  },
  {
    fieldName: 'last_visited',
    condition: 'after',
    value: null,
    sequence: 2,
    UIValue: null,
    type: 'lastSeenAfter',
  },
  {
    fieldName: 'last_visited',
    condition: 'more_than',
    value: null,
    sequence: 3,
    type: 'lastSeenMoreThan',
  },
  {
    fieldName: 'last_visited',
    condition: 'less_than',
    sequence: 4,
    value: null,
    type: 'lastSeenLessThan',
  },
]

export const projectState = [
  {
    condition: 'is_aware',
    value: '',
    sequence: 1,
    fieldName: 'project_activity',
    name: 'projects',
  },
  {
    condition: 'is_informed',
    value: '',
    sequence: 2,
    fieldName: 'project_activity',
    name: 'projects',
  },
  {
    condition: 'is_engaged',
    sequence: 3,
    value: '',
    fieldName: 'project_activity',
    name: 'projects',
  },
]
